<template>
  <nav :class="{ fixed: this.isFixed }">
    <span class="menu-line" :style="{ backgroundColor: color1 }"></span>
    <button class="show-menu" v-html="menuSVG" @click="showMenu()" @mouseover="showMenu()" :class="{ hover: menuVisible}" :style="{ fill: color1, 'pointer-events': !menuVisible }"></button>
  </nav>
</template>

<script>
import menuSVG from '../../static/images/menu.svg'
export default {
  name: 'Navigation',
  data () {
    return {
      menuSVG: menuSVG,
      menuVisible: false,
      color1: '#000',
      isFixed: false
    }
  },
  methods: {
    showMenu () {
      this.$bus.$emit('showMenu')
    }
  },
  destroyed () {
  },
  mounted () {
    this.$bus.$on('menuVisible', (visible) => {
      this.menuVisible = visible
    })
    this.$bus.$on('setColors', (color1) => {
      this.color1 = color1
      this.$forceUpdate()
    })
    this.$bus.$on('holdScreen', () => {
      this.isFixed = true;
    })
    this.$bus.$on('releaseScreen', () => {
      this.isFixed = false;
    })
  }
}
</script>

<style scoped lang="scss">
@import '../scss/variables';

nav {
  position: absolute;
  top: 0;
  left: 0;
  height: 200px;
  width: 100%;

  &.fixed {
    display: none;
  }
}

@keyframes line-animation {
  0%   { height: 0; }
  100% { height: .5vh; }
}

.menu-line {
  height: .9vh;
  width: 100%;
  position: absolute;
  animation: line-animation 1s;
  z-index: 3;
}

@keyframes menu-animation {
  0%   { transform: scale(.75); }
  100% { transform: scale(1); }
}

.show-menu {
  outline: none;
  border: none;
  background-color: transparent;
  height: 30px;
  width: 48px;
  cursor: pointer;
  position: absolute;
  left: 50%;
  margin-left: -25px;
  top: 28px;
  z-index: 5;


}

@media screen and (max-width: 64em) {
  .show-menu {
    margin-left: 0;
    left: 2px;
    top: 40px;
  }
}

@media screen and (max-width: 500px) {
  .show-menu {
    margin-left: 0;
    left: 2px;
    top: 7.5vw;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Navigation.vue